import { z } from 'zod';

// Mirrors the server-side AuthValidateModel.Code rules: exactly 6 digits.
export const authValidateSchema = z.object({
    code: z
        .string()
        .min(1, 'Required')
        .regex(/^\d{6}$/, 'Enter the 6-digit security code.'),
});
